// Value-imported from the compiled leaf file, NOT the `@avisoma/shared` barrel: the barrel pulls in
// Node `crypto` (RequestSignature), which Vite externalizes and blanks the app.
import {
  PROJECT_OPEN_ITEM_GROUP_KEYS,
  type ProjectOpenItemEntityType,
  type ProjectOpenItemGroup,
  type ProjectOpenItemGroupKey,
} from '@avisoma/shared/dist/api-schema/paths/api-projects-id-open-items.api.schema.js';

export const OPEN_ITEM_GROUP_LABELS: Record<ProjectOpenItemGroupKey, string> = {
  'pages-pending': 'Pages still processing',
  'documents-pending': 'Documents still reconstructing',
  'reconstructed-documents-pending': 'Reconstructed documents still extracting',
  'pages-error': 'Pages in error',
  'documents-error': 'Documents in error',
  'reconstructed-documents-error': 'Reconstructed documents in error',
};

export function openItemHref(entityType: ProjectOpenItemEntityType, id: string): string {
  switch (entityType) {
    case 'page':
      return `/document-pages/${id}`;
    case 'document':
      return `/documents/${id}`;
    case 'reconstructed-document':
      return `/reconstructed-documents/${id}`;
  }
}

export function groupsForIncludeErrors(
  groups: readonly ProjectOpenItemGroup[],
  includeErrors: boolean,
): ProjectOpenItemGroup[] {
  if (includeErrors) return [...groups];
  return groups.filter((group) => !group.key.endsWith('-error'));
}

/** Groups with a count, in the canonical key order. Count-0 groups are omitted. */
export function visibleOpenItemGroups(groups: readonly ProjectOpenItemGroup[]): ProjectOpenItemGroup[] {
  const byKey = new Map(groups.map((group) => [group.key, group]));
  return PROJECT_OPEN_ITEM_GROUP_KEYS.flatMap((key) => {
    const group = byKey.get(key);
    if (!group || group.count <= 0) return [];
    return [group];
  });
}

/**
 * Hide a fully clean project. Keep the card when errors are hidden so the
 * Include errors switch stays reachable.
 */
export function shouldShowOpenItemsSection(opts: {
  hasCounts: boolean;
  visibleCount: number;
  includeErrors: boolean;
}): boolean {
  if (!opts.hasCounts) return false;
  if (opts.visibleCount > 0) return true;
  return !opts.includeErrors;
}
